export default __webpack_public_path__ + "static/media/DSA.d4d5e47a.png";